import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActionConfirmationDialogValidator } from './action-confirmation-dialog-validator';
import { DialogBoxDataModel } from './dialog-box-data.model';
import { DialogBoxFormGroup } from './dialog-box-form-group';
import { AbstractActionConfirmationDialogComponent } from '../abstract-action-confirmation-dialog/abstract-action-confirmation-dialog.component';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import type { DialogBoxResultModel } from 'app/core/services/dialog-box/action-confirmation-dialog/dialog-box-result.model';
import type { ValidatorFn } from '@angular/forms';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-action-confirmation-dialog',
  styleUrls: ['./action-confirmation-dialog.component.scss'],
  templateUrl: './action-confirmation-dialog.component.html',
  imports: [AbstractActionConfirmationDialogComponent, FormsModule, ReactiveFormsModule, MatSlideToggle],
})
export class ActionConfirmationDialogComponent {
  public data: DialogBoxDataModel;
  public dialogRef = inject<MatDialogRef<ActionConfirmationDialogComponent>>(MatDialogRef);
  public formGroup: FormGroup<DialogBoxFormGroup>;

  private _data = inject<DialogBoxDataModel>(MAT_DIALOG_DATA);

  public constructor() {
    const _data = this._data;

    this.data = _data;
    if (!this._data.acceptLabel) {
      this.data.acceptLabel = 'Oui';
    }
    if (!this._data.declineLabel) {
      this.data.declineLabel = 'Non';
    }
    this._createForm(_data);
  }

  public onAcceptClickedHandler(): void {
    if (this._data.onAccept) {
      this._data.onAccept();
    }
    if (this._data.onAcceptWithOption) {
      this._data.onAcceptWithOption(this.formGroup.getRawValue() as DialogBoxResultModel);
    }
    this.dialogRef.close(true);
  }

  public onCloseClickedHandler(): void {
    this.dialogRef.close(true);
  }

  public onDeclineClickedHandler(): void {
    if (this._data.onDecline) {
      this._data.onDecline();
    }
    this.dialogRef.close(false);
  }

  private _createForm(dialogBoxData: DialogBoxDataModel): void {
    const dialogBoxValidators: ValidatorFn[] = [];
    if (dialogBoxData.requireValidationFlag) {
      dialogBoxValidators.push(ActionConfirmationDialogValidator);
    }

    this.formGroup = new FormGroup<DialogBoxFormGroup>(
      {
        optionValueFlag: new FormControl<boolean>(dialogBoxData.optionValueFlag!),
      },
      {
        validators: dialogBoxValidators,
      },
    );
  }
}
